export default __webpack_public_path__ + "static/media/A_wdt_c_cap_2.2e64b248.mp3";